import Icon         from "_components/atoms/icon";
import LightTooltip from "_components/atoms/lightToolTip";

import useStyles from "./styles";

function InputLeftSection ( { tooltipText } ) {
	const { classes } = useStyles ( {}, { name: "inputLeftSection" } );

	return (
		<LightTooltip
			arrow     = { true }
			placement = "top-start"
			title     = { tooltipText }
		>
			<div>
				<Icon
					sameInBothTheme
					className = { classes.rightSvgIcon }
					name      = "info-icon-grey"
					size      = { 20 }
				/>
			</div>
		</LightTooltip>
	);
}

export default InputLeftSection;
